import axios from 'axios'
import store from '../store'
import { Message } from 'element-ui'
// import {
//   Dialog
// } from 'vant'
import {
  getToken
} from '@/utils/auth'
import router from '../router'
import {
  showDelay,
  hideDelay
} from '@/utils/loading'
import bus from '@/utils/bus'

// axios.defaults.withCredentials = true
// 创建axios实例
// 创建axios实例
const service = axios.create({
  // transformRequest: [(data) => {
  //   // Do whatever you want to transform the data
  //   console.log(data)
  //   // return JSON.stringify(data)
  //   if(!data.___isformdata){
  //     return data
  //   }
  //   delete data.___isformdata
  //   let index = 0
  //   let ret = ''
  //   // const access_token = getToken()
  //   // if (access_token) {
  //   //   ret = 'access_token=' + access_token
  //   //   index++
  //   // }
  //   for (const it in data) {
  //     if (data[it] !== undefined) {
  //       if (index > 0) {
  //         ret += '&'
  //       }
  //       ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it])
  //       index++
  //     }
  //   }
  //   return ret
  // }],
  baseURL: process.env.BASE_API, // api的base_url
  timeout: 60000 // 请求超时时间
  //   headers: {
  //     'Content-Type': 'application/json;charset=UTF-8'
  // }
})
// request拦截器
service.interceptors.request.use(
  config => {

    if (config.loading) {
      showDelay()
    }
    //判断接口地址




    // console.log(config)
    if (getToken()) {
      // config.headers.common['Bearer'] = getToken()
      config.headers.common['Authorization'] = 'Bearer ' + getToken()
      if (config.method === 'get') {
        if (config.params) {
          config.params['access_token'] = getToken()
        } else {
          config.params = {
            access_token: getToken()
          }
        }
      } else {
        if (config.data) {
          config.data['access_token'] = getToken()
        } else {
          config.data = {
            access_token: getToken()
          }
        }
      }
    }
    return config
  },
  error => {
    // Do something with request error
    console.log(error) // for debug
    Promise.reject(error)
  }
)

// respone拦截器
service.interceptors.response.use(
  response => {

    if (response.config.url.endsWith('/userChatContent/add')) {
      if (localStorage.getItem('FrequencyLimit')) {
        bus.$emit('refreshCount')
      }

    }
    if (response.config) {
      if (response.config.loading) {
        hideDelay()
      }
    }
    /**
     * code为非20000是抛错 可结合自己业务进行修改
     */
    const res = response.data
    if (res.code !== 200) {
      // 50008:非法的token; 50012:其他客户端登录了;  50014:Token 过期了;
      // if (res.resultCode === '50008' || res.resultCode === 50012 || res.resultCode === 50014) {
      if (res.code === 401) {
        // Dialog.confirm({
        //   title: '提示',
        //   message: '你已被登出，可以取消继续留在该页面，或者重新登录'
        // }).then(() => {
        store.dispatch('FedLogOut').then(() => {

          if (router.currentRoute.path != '/build') {
            router.replace({
              path: '/build'
            })
            console.log('重新登录')
          } else {
            bus.$emit('showLogin')
          }

          // location.reload() // 为了重新实例化vue-router对象 避免bug
        })
        // }).catch(res => {
        //   router.push({
        //     name: '/home'
        //   })
        // })
      } else {
        if (res.code == 999 || res.code == 100403) {
          return response.data
        } else if (!(res.code > 2000 && res.code < 3000)) {
          setTimeout(() => {
            Message.success(res.message)
          }, 100)
        }
      }
      return Promise.reject(res)
    } else {
      return response.data
    }
  },
  error => {
    if (error && error.message) {
      const config = error.message.config
      if (config) {
        if (config.loading) {
          hideDelay()
        }
      }
    }
    // Toast(error.message)
    return Promise.reject(error)
  }
)
export default service



// WEBPACK FOOTER //
// ./src/utils/request.js